import { render, staticRenderFns } from "./NewKennelSignature.vue?vue&type=template&id=ff472226"
import script from "./NewKennelSignature.vue?vue&type=script&lang=ts"
export * from "./NewKennelSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports